import {Address} from "./address";

export interface FacilityDobryAgent {
  uuid: string;
  name: string;
  asf24AddressUuid?: string | null;
  affiliateCode?: string | null;
  url?: string | null;
  active: boolean;
  status?: DictionaryDobryAgent | null;
  address?: Address | null;
  city?: CityDobryAgent | null;
  description?: string;
  type?: DictionaryDobryAgent | null;
  serviceType?: DictionaryDobryAgent | null;
  phoneNumber?: string | null;
  email?: string | null;
  facebook?: string | null;
  website?: string | null;
  googlePlaceId?: string | null;
  googleBusinessUrl?: string | null;
  parking: boolean;
  accessibilityFeatures: boolean;
  bestAgents: boolean;
  openHours?: OpeningHoursModel;
  paymentMethods?: PaymentMethod[];
  subCategories?: SubCategory[];
  insuranceCompanies?: DobryAgentInsuranceCompany[];
  chronieInsuranceProducts?: ChronieInsuranceProduct[];
  featuredImage: ImageResponsive;
  galleryImage: ImageResponsive[];
  seoSlug?: string;
  seoTitle?: string;
  seoDescription?: string;
  seoKeywords?: string;
  coordinators?: Coordinator[];
  daysOffFromWork?: string[] | null;
  hasPendingVerification?: boolean;
  verification?: VerificationFacility[];
  //
  // linked?: boolean;
  //
  //
  //
  //
  // partners?: Array<{
  //   uuid: string;
  //   partnerId?: string | null;
  //   firstName?: string | null;
  //   lastName?: string | null;
  //   active?: boolean;
  // }>;
}

export interface DictionaryDobryAgent  {
  id: number
  name: string
  type: string
  key: string
  color?: string |null
  note?: string |null
  deleted?: boolean
}

export interface DayOpeningHours {
  openTime: string;
  closeTime: string;
}

export type OpeningHoursModel = Record<string, DayOpeningHours>;
export interface OpeningHoursViewItem {
  key: string;
  label: string;
  openTime: string;
  closeTime: string;
  closed: boolean;
}

export interface PaymentMethod {
  uuid: string;
  name: string;
  slug: 'blik' | 'transfer' | 'card' | 'cash' | string;
  active: boolean;
  icon?: string | null;
}

export interface PaymentMethodDobryAgent {
  uuid: string;
  name: string;
  slug: string;
  active: boolean;
  deleted: boolean;
  icon?: string | null;
}

export interface SubCategory {
  uuid?: string | null;
  name?: string | null;
  icon?: string | null;
  active?: boolean | null;
  position?: number | null;
  description?: string | null;
  category?: Category | null;
  seoSlug?: string | null;
  seoTitle?: string | null;
  seoDescription?: string | null;
  seoKeywords?: string | null;
  deleted?: boolean | null;
}

export interface Category {
  uuid: string;
  name: string;
  icon?: string;
  active?: boolean;
  position?: number;
  subCategories?: SubCategory[];
  deleted?: boolean;
}

export interface DobryAgentInsuranceCompany {
  uuid: string;
  name: string;
  slug: string;
  active: boolean;
  deleted: boolean;
}


export interface ChronieInsuranceProduct {
  uuid: string;
  name: string;
  category: string;
  title: string;
  description: string;
  heading: string;
  chronieUrl: string;
  svgIcon: string;
  bgColor: string;
  imageUrl: string;
  discount: string
  discountPrice: string;
  price: string;

}



export interface ImageResponsive {
  uuid: string,
  src: string,
  srcset: string,
  width: number,
  height: number,
  variants: FeaturedImageVariant[]
}

export interface FeaturedImageVariant {
  size: 'small' | 'medium' | 'large' | 'original';
  url: string;
  width: number;
  height: number;
  format: string;
}


export interface Coordinator {
  uuid: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  opinionsCount?: number;
  opinionsCountLabel?: string;
  opinionsAverage?: number;
  featuredImage: ImageResponsive;
  hasArticle?: boolean;
}

export interface CityDobryAgent {
  uuid: string;
  externalId: number;
  name: string;
  slug: string;
  district: string;
  voivodeship: string;
  community: string;
  latitude: string;
  longitude: string;
  localityType?: any;
}

export interface GooglePlaceDobryAgent {
  place_id: string;
  description: string;
  main_text: string;
  secondary_text: string;
  types: string[];
}


export interface VerificationFacility {
  uuid: string;
  facility?: FacilityDobryAgent;
  previous: VerificationData;
  changes: VerificationData;
  verificationStatus?: DictionaryDobryAgent | null;
  createdAt: string | Date;
  lastModifiedAt?: string | Date | null;
  deleted?: boolean;

  submittedByUserUuid?: string | null;
  submittedByFullName?: string | null;
  submittedByEmail?: string | null;
  rejectionReason?: string | null;
  reviewedByUserUuid?: string | null;
  reviewedByFullName?: string | null;
  reviewedByEmail?: string | null;
}


export interface VerificationData {
  name?: string;
  type?: DictionaryDobryAgent;
  serviceType?: DictionaryDobryAgent;
  street?: string;
  buildingNumber?: string;
  apartmentNumber?: string;
  city?: string;
  zipCode?: string;
  phoneNumber?: string;
  description?: string;
  website?: string;
  facebook?: string;
  parking?: boolean;
  accessibilityFeatures?: boolean;
  bestAgents?: boolean;
  openHours?: OpeningHoursModel;
  daysOffFromWork?: string[];
  paymentMethods?: PaymentMethod[];
  subCategories?: SubCategory[];
  insuranceCompanies?: DobryAgentInsuranceCompany[];
  email?: string;
  images?: VerificationImages[];
}

export interface VerificationImages {
  data?: string;
  uuid?: string;
  isNew: boolean;
  isDeleted: boolean;
  location?: string;
  position: string;
}


export interface OpeningHoursVerificationItem {
  key: string;
  label: string;
  openTime: string;
  closeTime: string;
  closed: boolean;
}

export const OpeningHoursDaysOrder = [
  { key: 'poniedzialek', label: 'Poniedziałek' },
  { key: 'wtorek', label: 'Wtorek' },
  { key: 'sroda', label: 'Środa' },
  { key: 'czwartek', label: 'Czwartek' },
  { key: 'piatek', label: 'Piątek' },
  { key: 'sobota', label: 'Sobota' },
  { key: 'niedziela', label: 'Niedziela' },
];


export const FacilityDobryAgentLabels: Record<string, string> = {
  name: 'Nazwa',
  type: 'Typ placówki',
  serviceType: 'Typ obsługi',
  street: 'Ulica',
  buildingNumber: 'Numer budynku',
  apartmentNumber: 'Numer lokalu',
  city: 'Miasto',
  zipCode: 'Kod pocztowy',
  phoneNumber: 'Telefon',
  email: 'Email',
  description: 'Opis',
  website: 'Strona www',
  facebook: 'Facebook',
  parking: 'Parking',
  accessibilityFeatures: 'Udogodnienia dla niepełnosprawnych',
  bestAgents: 'Najlepsi agenci',
  openHours: 'Godziny otwarcia',
  daysOffFromWork: 'Dni wolne',
  paymentMethods: 'Metody płatności',
  subCategories: 'Podkategorie',
  insuranceCompanies: 'Towarzystwa ubezpieczeniowe',
  images: 'Zdjęcia',
  seoSlug: 'SEO Slug',
  seoTitle: 'SEO Title',
  seoDescription: 'SEO Description',
  seoKeywords: 'SEO Keywords',
  googlePlaceId: 'Google Place ID',
  affiliateCode: 'Kod zniżkowy Chronie.pl',
};


export interface DobryAgentNotificationRecipient {
  userUuid: string | null;
  email: string;
  phoneNumber?: string | null;
  fullName?: string | null;
}

export interface DobryAgentBusinessCardNotificationSettings {
  key: string;
  recipients: DobryAgentNotificationRecipient[];
  emails?: string[];
  active: boolean;
}
